import {Component, EventEmitter, Input, OnInit, Output, ViewChildren} from '@angular/core';

@Component({
  selector: 'copart-custom-picklist',
  templateUrl: './custom-picklist.component.html',
  styleUrls: ['./custom-picklist.component.css']
})
export class CustomPicklistComponent implements OnInit {

  constructor( ) { }
  @Input() showCustomizeColumns : boolean = false;
  @Input() label : string;
  @Input() translateObject : any;
  @Input() source : any = [];
  @Input() target:  any =[];
  @Output() output = new EventEmitter();
  @Output() filter = new EventEmitter();
  @ViewChildren('preferredSelect') select;
  sourceFilter = "";
  targetFilter = "";
  addColumns:any [] = [];
  removeColumns: any[] = [];
  copy : any = {};
  searchSource : boolean = false;
  searchTarget : boolean = false;
  filterSource : any[] = []
  filterTarget : any[] = []
  ngOnInit() {
    this.copy.source = [...this.source];
    this.copy.target = [...this.target];
  }

  search(searchString, dataType){
    dataType == "source" ? this.doFilterSource(searchString) : this.doFilterTarget(searchString);
    if(searchString.length !== 0){
        if(dataType == "source"){
          this.searchSource = true;
        }else{
          this.searchTarget = true;
        }
    }else{
      this.searchSource = false;
      this.searchTarget = false;
    }
  }

  doFilterSource(filterBy: any) {
    this.sourceFilter = filterBy;
    filterBy = filterBy.toLocaleLowerCase();
    this.filterSource = filterBy ? this.source.filter((col: any) =>
      col[this.label].toLocaleLowerCase().indexOf(filterBy) !== -1) : [...this.source];
  }
  doFilterTarget(filterBy: any) {
    this.targetFilter = filterBy;
    filterBy = filterBy.toLocaleLowerCase();
    this.filterTarget = filterBy ? this.target.filter((col: any) =>
      col[this.label].toLocaleLowerCase().indexOf(filterBy) !== -1) : [...this.target];
  }

  changeAddColumns(options): void
  {
    this.addColumns = Array.apply(null,options).filter(option => option.selected);
  }

  changeRemoveColumns(options)
  {
    this.removeColumns = Array.apply(null, options).filter(option => option.selected);
  }

  addColumn(): void
  {
    this.addColumns.forEach( option => {
      this.target.push(this.source.find(column => column[this.label] == option.value));
      let index = this.source.indexOf(this.source.find(column => column[this.label] == option.value));
      this.source.splice(index, 1);
      
      const filterIndex = this.filterSource.indexOf(this.filterSource.find(column => column[this.label] == option.value));
      this.filterSource.splice(filterIndex, 1);

    });
    this.addColumns = [];
    this.doFilterTarget(this.targetFilter);
  }

  addAll(){
    this.source.forEach(column => this.target.push(column));
    this.source = [];
    this.filterSource =  [...this.source];
  }

  removeAll(){
    this.target.forEach(column => this.source.push(column));
    this.target = [];
  }

  removeColumn(): void
  {
    this.removeColumns.forEach( option => {
      this.source.push((this.target.find(column => column[this.label] == option.value)));
      let index = this.target.indexOf(this.target.find(column => column[this.label] == option.value));
      this.target.splice(index, 1);
      const filterIndex = this.filterTarget.indexOf(this.filterTarget.find(column => column[this.label] == option.value));
      this.filterTarget.splice(filterIndex, 1);
    });
    this.removeColumns = [];
    this.doFilterSource(this.sourceFilter);
  }

  doOutput(value){
    if(value)
      this.output.emit(this.target);
    else {
      this.source = [...this.copy.source];
      this.target = [...this.copy.target];
      this.output.emit(false);
    }
  }


}
